/* eslint-disable import/no-named-as-default-member */
import React, { useEffect, useState } from 'react';
import {
  Monitor as MonitorIcon,
  RefreshCw,
  Smartphone as PhoneIcon,
} from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import {
  CardMOList,
  DaySpotAndRangePicker,
  DeleteManufacOrderModal,
  Error,
  Loading,
  LoadingDialogWithTimeout,
  ManufacturingOrderExportExcelContainer,
  ManufacturingOrderTable,
  SocketIOLoading,
  ViewTitle,
} from '@iarcpsu/emanufac-components/src/components';
import {
  MANUFAC_ORDER_STATUS,
  MQ_TASK,
  PROCESS_STATUS,
} from '@iarcpsu/emanufac-constant';
import {
  ManufacturingOrderColumn,
  ManufacturingOrderWithProcessColumn,
} from '@iarcpsu/emanufac-utils/columns';
import {
  Button,
  Card,
  CardContent,
  FormControlLabel,
  InputAdornment,
  Switch,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import dayjs from 'dayjs';
import { gql } from 'graphql-request';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';

import { config } from '@/configs';

import graphqlClient from '../../../configs/graphqlClient';
import * as actions from '../../../redux/actions';
import * as CONSTANT from '../../../utils/constants';

/**
 * @function ManufactoringOrders
 * @memberof MMS/ManufacturingOrder
 * @description หน้าลิสต์รายการคำสั่งผลิต จะลิสต์มาที่ละ 5 อัน (Default) แต่ผู้ใช้สามารถเพิ่มได้
 * ใช้งานได้สองแบบจะมี Card Mode ที่ใช้ใทรศัพท์ กับ Table Mode ที่ใช้ใน Computer
 * Browser จะ Detect ให้เอง หน้านี้มีปัญหาด้านความช้าอยู่พอสมควร มีการใช้หลักการ Query Graphql
 * ไปที่ Server 2 รอบ รอบแรกเอาแค่ข้อมูล MO คร่าวๆ ส่วนครั้งที่2 ถึงไปใสั่งให้เอาข้อมูล Product
 * ต่างๆ มา อย่างร้อย User จะได้เห็นบางอย่างก่อน
 */
function ManufactoringOrders({ title, subtitle }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const manufacturingOrder = useSelector((state) => state.manufacturingOrder);
  const information = useSelector((state) => state.information);
  const me = useSelector((state) => state.me);
  const mmsSetting = information?.setting?.mms;

  const [searchTerm, setSearchTerm] = useState('');
  const [name, setName] = useState('');
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(5);
  const [total, setTotal] = useState(undefined);
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const [selectManufacOrder, setSelectManufacOrder] = useState();
  const [deleteLoadingOpen, setIsDeleteLoadingOpen] = useState(false);
  const [deleteReference, setDeleteReference] = useState();
  const [fullDataMO, setFullDataMO] = useState(null);
  const [useRedis, setIsUseRedis] = useState(true);
  const [selectedView, setSelectedView] = useState(
    window.screen.width >= 768
      ? CONSTANT.DISPLAY_TYPE.TABLE.status_code
      : CONSTANT.DISPLAY_TYPE.CARD.status_code,
  );
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isLateOnly, setIsLateOnly] = useState(false);
  const [isIncludeLog, setIsIncludeLog] = useState(false);
  const [orderByField, setOrderByField] = useState('createdAt');
  const [orderBy, setOrderBy] = useState('desc');
  const [isOnlyClaimed, setIsOnlyClaimed] = useState(false);

  useEffect(() => {
    dispatch(actions.manufacturingOrderReset());

    return () => {};
  }, []);

  const query = gql`
    query FindManufacturingOrder($input: ManufacturingOrderInput) {
      findManufacturingOrders(input: $input) {
        currPage
        lastPage
        total
        rows {
          _id
          id
          assigner {
            firstname
            lastname
          }
          prefix
          running_number
          customer {
            type_code
            name
            address
            phone_number
            rating
          }
          process {
            product {
              type_code
              name
            }
            produce_material_instead
            produce_base_project_instead
            base_project {
              type_code
              name
              unit
            }
            product_as_material {
              type_code
              name
            }
            current {
              index
              step {
                name
              }
            }
            current_step_name
            customer {
              type_code
              name
            }
            other_customers {
              name
            }
            quantity
            price_per_unit
            additional_unit
            remark
          }
          discount
          completed
          deleted
          start_date
          expected_date
          remark
          status
          is_claimed
        }
      }
    }
  `;

  const queryDataFromServer = async () => {
    try {
      const queryResult = await graphqlClient.request(query, {
        input: {
          page,
          size,
          name,
          enableFetchInside: false,
          fetchCurrentStep: false,
          fetchCustomer: false,
          fetchMaterial: false,
          fetchProduct: false,
          stage: isIncludeLog ? undefined : 'NORMAL',
          fetchProcess: false,
          forceWithoutCache: !useRedis,
          startDate: startDate
            ? dayjs(startDate).format('YYYY-MM-DD')
            : undefined,
          endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : undefined,
          status: isLateOnly
            ? MANUFAC_ORDER_STATUS.LATED.status_code
            : undefined,
          includeLog: isIncludeLog ? true : undefined,
          orderByField,
          orderBy,
          claimed: isOnlyClaimed ? true : undefined,
        },
      });

      const manufacturingOrderData = queryResult?.findManufacturingOrders;

      dispatch(actions.manufacturingOrderStateSet(manufacturingOrderData));
    } catch (err) {
      console.error('Mo,  Have an errors');
      dispatch(actions.manufacturingOrderReset());
    }
  };

  const callInsideFunction = async () => {
    try {
      console.log('Call Function Inside');
      const insideQuery = await graphqlClient.request(query, {
        input: {
          page,
          size,
          name,
          enableFetchInside: false,
          fetchCurrentStep: false,
          fetchCustomer: true,
          fetchMaterial: true,
          fetchProduct: true,
          fetchBaseProject: true,
          stage: isIncludeLog ? undefined : 'NORMAL',
          fetchProcess: true,
          forceWithoutCache: !useRedis,
          startDate: startDate
            ? dayjs(startDate).format('YYYY-MM-DD')
            : undefined,
          endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : undefined,
          status: isLateOnly
            ? MANUFAC_ORDER_STATUS.LATED.status_code
            : undefined,
          includeLog: isIncludeLog ? true : undefined,
          orderByField,
          orderBy,
          claimed: isOnlyClaimed ? true : undefined,
        },
      });

      const insidedQueryResult = insideQuery?.findManufacturingOrders;
      setFullDataMO(insidedQueryResult);
    } catch (error) {
      console.error(error?.message);
      dispatch(actions.manufacMaterialError());
    }
  };

  useEffect(() => {
    queryDataFromServer();
    console.log('Waiting for time to fetch inside');
    const fetchInsideTimeout = setTimeout(() => {
      callInsideFunction();
    }, 1000);
    return () => {
      console.log('Clear Fetch inside Timeout');
      clearTimeout(fetchInsideTimeout);
    };
  }, [
    name,
    page,
    size,
    useRedis,
    startDate,
    endDate,
    isLateOnly,
    isIncludeLog,
    orderByField,
    orderBy,
    isOnlyClaimed,
  ]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setName(searchTerm);
      setPage(1);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  useEffect(() => {
    setTotal(manufacturingOrder?.total);
    return () => {};
  }, [manufacturingOrder]);

  useEffect(() => {
    console.log('Full Data MOs is Toggle');
    if (fullDataMO && manufacturingOrder?.rows) {
      dispatch(actions.manufacturingOrderStateSet(fullDataMO));
    } else {
      console.log('แฮ่ แกเซ็ทไม่ได้หรอก');
    }
    return () => {};
  }, [fullDataMO]);

  const handleSocketIOFunction = {
    onSuccess: () => {
      setIsDeleteLoadingOpen(false);
      Swal.fire({
        icon: 'success',
        title: 'ยกเลิกคำสั่งผลิตสำเร็จ',
        text: 'คำสั่งผลิตถูกยกเลิกเรียบร้อยแล้ว',
      });
      dispatch(actions.manufacturingOrderReset());
      queryDataFromServer();
      setDeleteReference();
    },
    onFail: (args) => {
      setIsDeleteLoadingOpen(false);
      console.log('Error', args?.error);
      Swal.fire({
        icon: 'error',
        title: 'ยกเลิกคำสั่งผลิตไม่สำเร็จ',
        text: args?.message,
      });
      dispatch(actions.manufacturingOrderReset());
      queryDataFromServer();
      setDeleteReference();
    },
  };

  const manufacturingOrderAPIQuery = {
    page: 1,
    size: config.maxFetchSize,
    name: '',
    enableFetchInside: '',
    fetchCurrentStep: '',
    fetchCustomer: true,
    fetchMaterial: true,
    fetchProduct: true,
    fetchBaseProject: true,
    stage: isIncludeLog ? '' : 'NORMAL',
    fetchProcess: true,
    forceWithoutCache: true,
    startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
    endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
    status: isLateOnly ? MANUFAC_ORDER_STATUS.LATED.status_code : '',
    includeLog: isIncludeLog ? true : '',
    orderByField,
    orderBy,
    claimed: isOnlyClaimed ? true : '',
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;
  const renderSearch = () => (
    <Card>
      <div className="p-4 flex flex-row justify-between">
        <div className="w-8/12 md:w-5/12">
          <TextField
            label="ค้นหา"
            fullWidth
            size={'small'}
            id="outlined-start-adornment"
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="fas fa-search"></i>
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="md:w-4/12 lg:w-2/12 px-1">
          <FormControlLabel
            control={
              <Switch
                onChange={(e) => setIsLateOnly(e.target.checked)}
                checked={isLateOnly}
              />
            }
            label="เฉพาะเลยกำหนด"
          />
        </div>
        <div className="md:w-4/12 lg:w-2/12 px-1">
          <FormControlLabel
            control={
              <Switch
                onChange={(e) => setIsIncludeLog(e.target.checked)}
                checked={isIncludeLog}
              />
            }
            label="รวมรายการที่สำเร็จ/ยกเลิก"
          />
        </div>
        <div className="lg:w-2/12 px-1 md:w-2/12">
          <ManufacturingOrderExportExcelContainer
            sheetName="ManufacturingOrder"
            dataQuery={manufacturingOrderAPIQuery}
            currentData={manufacturingOrder?.rows}
            dataAPIEndPoint="manufacturing-order"
            columnList={ManufacturingOrderColumn(information)}
            processColumnList={ManufacturingOrderWithProcessColumn(information)}
          />
        </div>
        <div className="w-1/12 px-1 flex justify-end">
          <ToggleButtonGroup
            value={selectedView}
            exclusive
            size="small"
            onChange={(event, value) => setSelectedView(value)}
          >
            <ToggleButton value={CONSTANT.DISPLAY_TYPE.TABLE.status_code}>
              <MonitorIcon size="16" />
            </ToggleButton>
            <ToggleButton value={CONSTANT.DISPLAY_TYPE.CARD.status_code}>
              <PhoneIcon size="16" />
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
      </div>
    </Card>
  );

  const handleToInfoPage = (id) => {
    history.push(`manufacturing-orders/view/${id}`);
  };

  const handlePushToEditPage = (id) => {
    history.push(`manufacturing-orders/edit/${id}`);
  };

  const handleToDistributeMaterial = (id) => {
    history.push(`material-distribute/${id}`);
  };

  const handleModalDeleteOpen = (selectManufac) => {
    setSelectManufacOrder(selectManufac);
    setIsModalDeleteOpen(true);
  };

  const handleModalDeleteClose = () => {
    setIsModalDeleteOpen(false);
    setSelectManufacOrder();
  };

  const handleDelete = async (id) => {
    console.log('Delete Manufacturing Order', id);
    const tempManufacOrder = _.find(
      manufacturingOrder?.rows,
      (_manufacOrder) => _manufacOrder?._id === id,
    );

    handleModalDeleteOpen(tempManufacOrder);
  };

  const handleChangeRowsPerPage = (event) => {
    setSize(event.target.value);
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
  };

  const handleCreateProductionLine = (manufacOrderId, productId) => {
    history.push(`create-production-line/${manufacOrderId}/${productId}`);
  };

  const handleStartProcess = async (processId) => {
    const confirm = window.confirm('ยืนยันการเริ่มการผลิต');
    if (confirm) {
      try {
        await dispatch(
          actions.processPut(processId, {
            status: PROCESS_STATUS.PROCESS_IN_PROGRESS.status_code,
            emplyoeeId: me?.userData?._id,
          }),
        );
        await dispatch(actions.manufacturingOrderAll({ name, page, size }));
      } catch (error) {
        console.error(error);
      }
    }
  };

  const tableProps = {
    handleChangePage,
    handleChangeRowsPerPage,
    handleCreateProductionLine,
    handleDelete,
    handlePushToEditPage,
    handleStartProcess,
    handleToDistributeMaterial,
    handleToInfoPage,
    manufacturingOrder,
    page,
    size,
    total,
    orderByField,
    orderBy,
    setOrderByField,
    setOrderBy,
  };

  const renderTable = () => (
    <div>
      {selectedView === CONSTANT.DISPLAY_TYPE.TABLE.status_code ? (
        <ManufacturingOrderTable {...tableProps} />
      ) : (
        <CardMOList {...tableProps} />
      )}
    </div>
  );

  const renderDeleteModal = () => (
    <DeleteManufacOrderModal
      handleClose={handleModalDeleteClose}
      isOpen={isModalDeleteOpen}
      manufacturingOrder={selectManufacOrder}
      successHandle={(referenceNumber) => {
        handleModalDeleteClose();
        setIsDeleteLoadingOpen(true);
        setDeleteReference(referenceNumber);
      }}
    />
  );

  const renderOnlyAddButton = () => {
    if (mmsSetting?.authorization?.admin_only_create_mo) {
      if (me?.userData?.role?.level >= 1) {
        return (
          <Link to="manufacturing-orders/create">
            <Button variant="contained">เพิ่ม</Button>
          </Link>
        );
      }

      return (
        <Button variant="contained" disabled>
          เพิ่ม
        </Button>
      );
    }
    return (
      <Link to="manufacturing-orders/create">
        <Button variant="contained">เพิ่ม</Button>
      </Link>
    );
  };

  const renderAddButton = () => (
    <div className="flex flex-row justify-end pb-4 gap-1">
      <div>{renderOnlyAddButton()}</div>

      <Button
        variant="contained"
        color="teal"
        startIcon={<RefreshCw size={16} />}
        onClick={() => {
          setIsUseRedis(false);
        }}
      >
        รีเฟรช
      </Button>
    </div>
  );

  if (manufacturingOrder?.isLoading) {
    return <Loading />;
  }

  if (!manufacturingOrder?.isLoading && manufacturingOrder?.isCompleted) {
    return (
      <div>
        <div className="flex justify-between">
          <div>{renderTitle()}</div>
          <div className="mt-6">{renderAddButton()}</div>
        </div>
        <LoadingDialogWithTimeout
          isLoading={deleteLoadingOpen}
          label="กำลังลบคำสั่งผลิต"
          action="REFRESH"
        />
        <SocketIOLoading
          taskCode={MQ_TASK.UPDATE_MANUFAC_ORDER.status_code}
          referenceNumber={deleteReference}
          handleSuccess={handleSocketIOFunction.onSuccess}
          handleFail={handleSocketIOFunction.onFail}
        />
        {renderDeleteModal()}
        {renderSearch()}
        <Card className="my-2">
          <CardContent>
            <div className="flex flex-wrap items-center">
              {information?.setting?.mms?.enableClaimedMO && (
                <div className="w-full lg:w-1/5">
                  <FormControlLabel
                    control={
                      <Switch
                        defaultChecked={isOnlyClaimed}
                        onChange={(e) => setIsOnlyClaimed(e.target.checked)}
                      />
                    }
                    label="เฉพาะงานเคลม"
                  />
                </div>
              )}
              <div className="w-full lg:w-4/5">
                <DaySpotAndRangePicker
                  enable
                  flex
                  setEndDate={setEndDate}
                  setStartDate={setStartDate}
                  startDate={startDate}
                  endDate={endDate}
                  size="small"
                />
              </div>
            </div>
          </CardContent>
        </Card>{' '}
        {renderTable()}
      </div>
    );
  }
  return <Error />;
}

ManufactoringOrders.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

ManufactoringOrders.defaultProps = {
  title: '',
  subtitle: '',
};

export default ManufactoringOrders;
